import { StyleRules, Theme } from '@material-ui/core/styles'

import { extendStyles } from '../common/styleUtils'

export const makeAccountNavStyles =
  ({palette}: Theme) => ({
    accountName: {
      fontSize: 14,
      fontWeight: 700,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      // TODO: (routing) Ask if multiline + tooltip are needed 2/2
      whiteSpace: 'normal',
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': 4
    },
    accountInfo: {
      padding: '10px 10px 10px 22px',
      cursor: 'pointer'
    },
    listItemIcon: {
      minWidth: 30
    },
    listItem: {
      padding: '2.5px 0 2.5px 10px',
      '&:hover': {
        color: palette.text.primary,
        backgroundColor: palette.mpSkladPrimary.white
      }
    },
    listItemText: {
      '& span': {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '14.4px'
      }
    },
    deleteIcon: {
      width: '12px'
    }
  }) satisfies StyleRules

// BUG: Don't export style hooks - style tags are rendered out of order, imported styles are overriding importee's styles
// TODO: Splitting the object and hook is the correct way, use for new components. Don't touch existing, breaks stuff.
export const extendAccountNavStyles = extendStyles(makeAccountNavStyles)